module.exports = __webpack_public_path__ + "static/media/038.81c20635.jpg";